import React from "react";
import { connect } from 'react-redux'
import { setQuestionAnswer, removeDataFromArray } from '../../api/questionnaires/actions'
import { ConditionalModal } from "../modals";
import { SvgArrowIcon, SvgCheckIcon, SvgTrashIcon } from '../svg';


class QuestionnaireTemplate extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			testing: true
		}

		// In case we need to add yes/no types
		this.yesNoThirdKeys = {
			'idk': "Veit ekki"
		}

		this.renderBlock = this.renderBlock.bind(this)
		this.renderTitle = this.renderTitle.bind(this)
		this.renderQuestionsFromType = this.renderQuestionsFromType.bind(this)
		this.renderYesOrNoQuestions = this.renderYesOrNoQuestions.bind(this)
		this.shouldBeChecked = this.shouldBeChecked.bind(this)
		this.selectAnswer = this.selectAnswer.bind(this)
		this.isConditionFulfilled = this.isConditionFulfilled.bind(this)
		this.processConditionals = this.processConditionals.bind(this)
		this.renderConditionals = this.renderConditionals.bind(this)
		this.getQuestionValue = this.getQuestionValue.bind(this)
		this.addMultiAnswer = this.addMultiAnswer.bind(this)

		// this.addCheckboxesAnswer = this.addCheckboxesAnswer.bind(this)
	}

    /* GETTERS AND SETTERS FOR PROPS */
	selectAnswer(id, e) {
		this.props.dispatch(setQuestionAnswer(id, e.target.value, this.props.customerId, this.props.questionnaireId))
	}

    addMultiAnswer(id, answer) {
        let arr = this.getQuestionValue(id) ? this.getQuestionValue(id) : [];
        arr.push(answer)
        this.props.dispatch(setQuestionAnswer(id, arr, this.props.customerId, this.props.questionnaireId))
    }

    removeDataFromArray(id, index){
        this.props.dispatch(removeDataFromArray(id, index, this.props.customerId, this.props.questionnaireId))
    }

    /* HELPER FUNCTIONS */

	// If question has been answered, return value else return false
	getQuestionValue(id) {
		if (this.props.questionnaires.answers[this.props.customerId] && this.props.questionnaires.answers[this.props.customerId][this.props.questionnaireId] && this.props.questionnaires.answers[this.props.customerId][this.props.questionnaireId][id]) {
			return this.props.questionnaires.answers[this.props.customerId][this.props.questionnaireId][id]
		}
		return false
	}

	// Helper function for isConditionFulfilled
	// Goes through questions and checks if they are part of the group that needs to be
	// fulfilled for display, and if the value matches value set (eg. true)
	checkSubgroupHelper(questions, group, value) {
		let returnVal = false
		questions.forEach((item, index) => {
			if (item.value.subgroup === group) {
				returnVal = returnVal | this.getQuestionValue(item.id) == value
			}
		});
		return returnVal
	}

	// conditionalArray = [Group to be fulfilled (A,B..), type ('any', 'all'), value (true, false)]
	isConditionFulfilled(condition) {
		let { questions } = this.props;
		let [group, delim, value] = condition.split(' ')

		// If more than one group needs to be true (A,E for example)
		if (group.includes(',')) {
			let valArr = []
			group.split(',').forEach((item, index) => {
				valArr[index] = this.checkSubgroupHelper(questions, item, value)
			})
			return valArr.every(element => element === true);
		} else {
			return this.checkSubgroupHelper(questions, group, value)
		}
	}

    // Nested is label matched in case we're working with multiple data undir same ID
    shouldBeChecked(id, targetValue, nested=false) {
		// If question hasn't been answered, nothing should be checked
		if (!this.props.questionnaires.answers[this.props.customerId] || 
			!this.props.questionnaires.answers[this.props.customerId][this.props.questionnaireId] || 
			!this.props.questionnaires.answers[this.props.customerId][this.props.questionnaireId][id]) {
            return false
		} 
        // else if (nested){
        //     if (!this.props.questionnaires.answers[this.props.customerId][this.props.questionnaireId][id][nested]){
        //         return false
        //     }
        //     return this.props.questionnaires.answers[this.props.customerId][this.props.questionnaireId][id][nested] === targetValue
		// } else {
		// 	return this.props.questionnaires.answers[this.props.customerId][this.props.questionnaireId][id] === targetValue
		// }
        return this.props.questionnaires.answers[this.props.customerId][this.props.questionnaireId][id] === targetValue
	}

    /* CONDITIONAL QUESTIONS */

    renderConditionalCheckboxes(id, conditions){
        let qArr = conditions.value
        return <div className="ConditionalCheckboxes pl-5">
                {this.renderCheckboxes(qArr, conditions.id)}
            </div> 
    }

    // Display a table of conditional headers and answers (array)
	renderMultiAnswerBoxConditionals(id, question) {
        let answerArray = this.getQuestionValue(id)
		const conditional_questions = question[0].conditional_question;

		return <>
		{ answerArray && 
			<div className="question-wrapper mobile-overflow">
				<div className="row mb-4 border-bottom mobile-full">
				{  conditional_questions.map((item, index) => {
					return <div key={index} className="col bold">{ item.value && (item.value.label || (item.value[0] && item.value[0].label)) || '' }</div>
				})
				}
				</div>
                { answerArray.map((group, index) => {
					return <div key={index} className="row py-1 mobile-full position-relative">
							{ conditional_questions.map((item, index) => {
								return <div key={index} className="col">{ group[item.id] }</div>
							})}
							<button className="trash position-absolute" onClick={(e) => this.removeDataFromArray(id, index)}><SvgTrashIcon /></button>
						</div>
				})}
			</div>
        }
		{ this.renderMultiAnsQuestionBtn(id, question)}
		</>
	}

    // Make sure ID matches correct question (or any if case) bf this func
    // skip_check for conditionals that have no display requirements
    // third for nested parameters under one id, f.ex. "1023xj1": { 'Trial': "true", ... }
	renderConditionals(id, conditional_questions, skip_check = false) {
		if (this.shouldBeChecked(id, 'true') || skip_check) {
			return conditional_questions.map((item, index) => {
				let accessor = item
				if (item.value) {
					accessor = item.value
				}
				if (item.type === 'conditional_date' || item.type === 'conditional_question') {
					return this.renderOneSingleLineQuestion(item, item.id)
				} else if (item.type === 'conditional_text') {
					return <div key={index} className="question-wrapper mt-5">{accessor.label}</div>
                } else if (item.type === 'conditional_checkboxes') {
                    return this.renderConditionalCheckboxes(id, item)
				} else {
					return <div key={index}>Conditional of type {item.type} not supported</div>
				}
			})
		}
	}

    // Only supports lastTrue for now
	processConditionals(conditions, id, question_type, questions) {
		if (question_type === 'multi_answer_box') {
			return this.renderMultiAnswerBoxConditionals(id, conditions);
		}

		return conditions.map((item, index) => {
			if (item.condition === "lastTrue") {
				let lastCheckboxId = questions.length > 1 ? id + '-' + questions.length : id;
				if (question_type === 'checkbox' || question_type === 'yes_no') {
					return this.renderConditionals(lastCheckboxId, item.conditional_question)
				} else if (question_type === 'checkboxes') {
					return this.renderConditionals(lastCheckboxId, item.conditional_question)
				} else {
					return this.renderConditionals(lastCheckboxId, item.conditional_question, true)
				}
			}
		})
	}

    /* QUESTIONS */

	renderMultiAnsQuestionBtn(id, question) {
        return <>
            <div className="qa button question-wrapper border-0 pt-0">
                {/* <label className="question">{question.value.title}</label> */}
                <button className="btn btn-primary answer mt-4" data-toggle="modal" onClick={(e) => e.preventDefault()} data-target={"#ConditionalModal-" + id}>Bæta við</button>
            </div>
            <ConditionalModal id={"ConditionalModal-" + id} questionId={id} question={question} store={this.props.store} addMultiAnswer={this.addMultiAnswer}/>
        </>
    }

	renderOneSingleLineQuestion(q, id) {
		let accessor = q
		if (q.value) {
			accessor = q.value
		}

		let label = (accessor.label == "NONE" ? "" : accessor.label)
		return (
		<div key={id} className="question-wrapper d-flex">
			<label className={`question${this.getQuestionValue(id) ? ' error' : ''}`} htmlFor={id}>{label}{accessor.tooltip && <>&nbsp;<Tooltip text={accessor.tooltip} /></>}</label>
			<input className="answer input col" type="text" id={id} onChange={(e) => this.selectAnswer(id, e)} value={this.getQuestionValue(id) ? this.getQuestionValue(id) : ""}></input>
		</div>
		)
	}

	// For question group, takes in question qroup ID and concats index if needed
	renderSingleLineQuestions(questions, id) {
		// If questions > 1, need to concat index to ID
		if (questions.length > 1) {
			return (<>
				<div className="qa singleline multiple-qa">
					{questions.map((q, index) => {
						let question_id = id + '-' + (index + 1)
						return this.renderOneSingleLineQuestion(q, question_id)
					})}
				</div>
			</>)
		} else if (questions.length == 1) {
			return this.renderOneSingleLineQuestion(questions[0], id)
		}
		// Be careful with an "else" here, we have question groups of type singleLine w/o any questions
	}

	// Does not support > 1 multiline per question group as is. To add: append index to id
	renderMultiLineQuestions(questions, id) {
		return (
			<div key={id} className={`qa multiline multiple-q`}>
				{questions.map((q, index) => {
					let q_id = questions.length > 1 ? id + '-' + (index + 1) : id
					return (
						<div key={index} className="question-wrapper">
							<label style={{display: 'block'}} className="question" htmlFor={q_id}>{q.label}</label>
							<textarea rows="3" className="answer textareabox" type="text" id={q_id} onChange={(e) => this.selectAnswer(q_id, e)} value={this.getQuestionValue(q_id) ? this.getQuestionValue(q_id) : ""}></textarea>
						</div>
					)
				})}
			</div>
		)
	}


	// Render single checkbox
	renderCheckbox(q, id) {
		let accessor = q
		if (q.value) {
			accessor = q.value
		}

		return (
			<div key={id} className={`qa radio question-wrapper border-0`}>
				<div className="answer radio">
					<div className="checkbox">
						<input type="checkbox" id={id} checked={this.shouldBeChecked(id, "true")}  name={id} value={!this.shouldBeChecked(id, "true")} onChange={(e) => this.selectAnswer(id, e)}></input>
						<label htmlFor={id}>{accessor.label}</label>
					</div>
				</div>
			</div>
		)
	}

    // addCheckboxesAnswer(id, label, e){
    //     let object = this.getQuestionValue(id) ? this.getQuestionValue(id) : {};
    //     // arr.push({[label]: e.target.value})
    //     object[label] = e.target.value
    //     console.log("CheckboxesAns: ", object)
    //     this.props.dispatch(setQuestionAnswer(id, object, this.props.customerId, this.props.questionnaireId))
    // }

	// Render > 1 checkboxes in question block, type: checkboxes (hakreitir)
	renderCheckboxes(questions, id) {
		return <>
			{questions.map((q, i) => {
				let accessor = q
				if (q.value) {
					accessor = q.value
				}

				return this.renderCheckbox(accessor, id + '-' + (i+1))
                let q_id = id + '-' + (i + 1)
                // return <> 
                //     {/* <div className={`qa radio question-wrapper border-0`}>
                //         <div className="answer radio">
                //             <div className="checkbox">
                //                 <input type="checkbox" id={q_id} checked={this.shouldBeChecked(id, "true", q.label)} defaultChecked={this.shouldBeChecked(id, "false", q.label)} name={id} value={!this.shouldBeChecked(id, "true", q.label)} onChange={(e) => this.addCheckboxesAnswer(id, q.label, e)}></input>
                //                 <label htmlFor={q_id}>{q.label}</label>
                //             </div>
                //         </div>
                //     </div> */}
                // </>
			})
			}
		</>
	}

	// Supports 2-3 checkboxes (Yes, No & other)
	renderYesOrNoQuestions(questions, id, third_key = "") {
		return questions.map((question, index) => {
			let accessor = question
			if (question.value) {
				accessor = question.value
			}
			// If multiple yes_no questions in same group, append index to ID
			let q_id = questions.length > 1 ? id + '-' + (index + 1) : id
			return (
				<div key={index} className="question-wrapper row d-flex">
					<div className="question">{accessor.label}{accessor.tooltip && <>&nbsp;<Tooltip text={accessor.tooltip} /></>}</div>
					<div className="answer yes-and-no row col d-flex justify-content-end">
						<div>
							<input type="radio" id={q_id + "-yes"} checked={this.shouldBeChecked(q_id, "true")} name={q_id} value={true} onChange={(e) => this.selectAnswer(q_id, e)}></input>
							<label htmlFor={q_id + "-yes"}>Já</label>
						</div>
						<div>
							<input type="radio" q_id={q_id + "-no"} checked={this.shouldBeChecked(q_id, "false")} name={q_id} value={false} onChange={(e) => this.selectAnswer(q_id, e)}></input>
							<label htmlFor={q_id + "-no"}>Nei</label>
						</div>
						{ third_key &&
							<div>
								<input type="radio" q_id={q_id + "-" + third_key} checked={this.shouldBeChecked(q_id, "idk")}  name={q_id} value={third_key} onChange={(e) => this.selectAnswer(q_id, e)}></input>
								<label htmlFor={q_id + "-" + third_key}>{this.yesNoThirdKeys[third_key]}</label>
							</div>
						}
					</div>
				</div>
			)
		})
	}

	// Only supports one question as is
	renderMultAnsQuestions(questions, id, conditionals) {
		let accessor = questions[0]
		if (questions[0].value) {
			accessor = questions[0].value
		}
        let label = (accessor.label == "NONE" ? "" : accessor.label)

		return <div className="question-wrapper border-bottom-0"><div className="question">{label}</div></div>
	}

	renderQuestionsFromType(questions, question_type, id) {
		switch (question_type) {
            case 'date':
			case 'singleline':
				return this.renderSingleLineQuestions(questions, id)
			case 'multiline':
				return this.renderMultiLineQuestions(questions, id)
			case 'checkbox':
				return this.renderCheckbox(questions[0], id)		 // Type 'checkbox' (hakreitur) should only contain ONE question
			case 'checkboxes':
				return this.renderCheckboxes(questions, id)
			case 'yes_no':
				return this.renderYesOrNoQuestions(questions, id)
			case 'yes_no_idk':
				return this.renderYesOrNoQuestions(questions, id, 'idk')
			case 'multi_answer_box':
				return this.renderMultAnsQuestions(questions, id)
			default:
				return <div>Type {question_type} not supported</div>
		}
	}

    /* TITLE */

	renderTitle(title) {
		return <>{title && <h4 className="title">{title}</h4>} </>
	}

	// Display title, questions and conditional questions
	renderBlock(block,index) {
		let { title, questions, question_type, conditions } = block.value
		let { id } = block

		return <div key={index}>
			{this.renderTitle(title)}
			{this.renderQuestionsFromType(questions, question_type, id)}
			{this.processConditionals(conditions, id, question_type, questions)}
		</div>
	}

	render() {
		let { questions } = this.props;

		return (
			<>
				{questions.map((block,index) => { 	// Block has condition for rendering and it's fulfilled
					if (block.value.display_on_condition && this.isConditionFulfilled(block.value.display_condition)) {
						return this.renderBlock(block,index)
					} else if (!block.value.display_on_condition) { // No condition for rendering block
						return this.renderBlock(block,index)
					}
				}
				)}
			</>
		)
	}
}

function mapStateToProps(state) {

	var f = {
		questionnaires: {},
	}
	f.questionnaires = (state.questionnaires === undefined) ? {} : state.questionnaires
	// if we are not receiving any answers via the store we check if there is any tilbod with answers
	if (f.questionnaires.answers && Object.keys(f.questionnaires.answers).length == 0 && state.tilbod && state.tilbod.jsondata) {
		f.questionnaires.answers = {... state.tilbod.jsondata.answers}
	}

	return f;
}

export default connect(mapStateToProps)(QuestionnaireTemplate);